import Vue from 'vue';
import App from './App.vue';
import Vant from 'vant';
import 'vant/lib/index.css';
import router from './router';
import http from './http';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import common from './common/function'
import 'swiper/swiper-bundle.css'
import store from './store'

import 'video.js/dist/video-js.css'
import i18n from './i18n';
import { getStoredLanguage, persistLanguage } from './i18n/language';
import { ensureLatestVersion, startVersionWatcher } from './common/versionGuard';

import enhancedCacheManager from './common/enhancedCache';
import VueDPlayer from "vue-dplayer";
import "vue-dplayer/dist/vue-dplayer.css";
import '@vant/touch-emulator';

// ✅ 导入 axios
import axios from 'axios';

Vue.use(VueDPlayer);
Vue.prototype.$http = http
Vue.prototype.common = common
Vue.prototype.$cache = enhancedCacheManager
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper)
Vue.use(Vant);

// ✅ 语言映射配置
const languageMap = {
  'ko': 'ko-KR',
  'zh-CN': 'zh-CN', 
  'en': 'en-US',
  'jp': 'ja-JP',
  'vi': 'vi-VN',
  'hi': 'hi-IN',
  'th': 'th-TH',
  'ru': 'ru-RU'
  ,'es': 'es-ES'
  ,'fr': 'fr-FR'
  ,'de': 'de-DE'
  ,'it': 'it-IT'
}

// ✅ 获取当前语言并设置语言头
const currentLanguage = persistLanguage(getStoredLanguage());
const backendLanguage = languageMap[currentLanguage] || 'en-US';

// ✅ 设置 axios 默认语言头
axios.defaults.headers.common['Accept-Language'] = backendLanguage;

// ✅ 添加请求拦截器确保每个请求都有语言头
axios.interceptors.request.use(config => {
  const lang = persistLanguage(getStoredLanguage());
  const backendLang = languageMap[lang] || 'en-US';
  config.headers['Accept-Language'] = backendLang;
  return config;
});

// 简单的路由守卫，确保注销后跳转到登录页
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  
  // 如果没有 token 且不在登录/注册页，跳转到登录页
  if (!token && to.path !== '/Login' && to.path !== '/Register') {
    next('/Login')
    return
  }
  
  // 如果有 token 且在登录页，跳转到首页
  if (token && to.path === '/Login') {
    next('/Home')
    return
  }
  
  next()
})

const DESKTOP_FRAME_PARAM = '__desktop_frame';

function isDesktopBrowser() {
  const isMobileAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  return !isMobileAgent && window.innerWidth > 768;
}

function isAuthHash(hash = window.location.hash) {
  return /^#\/(?:Login|Register)(?:[/?]|$)/i.test(hash);
}

function isEmbeddedDesktopFrame() {
  return new URLSearchParams(window.location.search).get(DESKTOP_FRAME_PARAM) === '1';
}

function shouldUseDesktopFrame() {
  return isDesktopBrowser()
    && !isEmbeddedDesktopFrame()
    && !isAuthHash()
    && Boolean(localStorage.getItem('token'));
}

function mountVueApplication() {
  new Vue({
    store,
    router,
    i18n,
    render: h => h(App),
  }).$mount('#app');
  startVersionWatcher();
}

function mountDesktopFrame() {
  document.body.classList.add('desktop-device', 'desktop-frame-host');

  const frameUrl = new URL(window.location.href);
  frameUrl.searchParams.set(DESKTOP_FRAME_PARAM, '1');

  const frame = document.createElement('iframe');
  frame.className = 'desktop-mobile-frame';
  frame.title = 'Soulmate';
  frame.src = frameUrl.toString();
  frame.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; clipboard-read; clipboard-write');
  frame.setAttribute('allowfullscreen', '');
  frame.setAttribute('scrolling', 'no');
  document.body.appendChild(frame);

  window.addEventListener('message', event => {
    if (event.origin !== window.location.origin || event.source !== frame.contentWindow) return;
    if (!event.data || event.data.type !== 'desktop-frame-route') return;

    const nextHash = event.data.hash || '#/Home';
    const nextUrl = `${window.location.pathname}${window.location.search}${nextHash}`;
    window.history.replaceState(null, '', nextUrl);
    if (event.data.title) document.title = event.data.title;

    if (isAuthHash(nextHash)) {
      window.location.reload();
    }
  });

  window.addEventListener('hashchange', () => {
    if (!frame.contentWindow) return;
    const nextHash = window.location.hash || '#/Home';
    if (frame.contentWindow.location.hash !== nextHash) {
      frame.contentWindow.location.hash = nextHash;
    }
  });
}

ensureLatestVersion().then(ready => {
  if (!ready) return;
  if (shouldUseDesktopFrame()) {
    mountDesktopFrame();
    return;
  }
  mountVueApplication();
});
